import {Component, ElementRef, EventEmitter, Input, Output, inject} from '@angular/core';
import {Severity} from '../../../../types/severity';
import {NotificationStatus} from '../../../../types/notifications.type';
import {NotificationCardComponent} from '../notification-card/notification-card.component';
import {NgClass} from '@angular/common';
import {MatIconModule} from '@angular/material/icon';

@Component({
  standalone: true,
  selector: 'mc-notification-item',
  templateUrl: './notification-item.component.html',
  styleUrls: ['./notification-item.component.scss'],
  imports: [NotificationCardComponent, NgClass, MatIconModule],
})
export class NotificationItemComponent {
  private notificationContent = inject(ElementRef);

  @Input() severity: Severity = 'primary';
  @Input() status: NotificationStatus;
  @Output() read = new EventEmitter();
  expanded = true;
  minItemHeight = 62; // minimal height for notification with content in one line
  notificationStatus = NotificationStatus;
  get notificationNotReaded() {
    return this.status && this.status === NotificationStatus.NEW;
  }
  get notificationDismiss() {
    return this.status && this.status === NotificationStatus.DISMISS;
  }

  get showExpandIcon(): boolean {
    if (!this.notificationContent) return false;
    const elementHeight = this.notificationContent.nativeElement.offsetHeight;
    return elementHeight >= this.minItemHeight;
  }

  onClickAction(event: Event, status: NotificationStatus) {
    event.stopPropagation();
    this.read.emit(status);
  }
  onExpandAction(event: Event) {
    event.stopPropagation();
    this.expanded = !this.expanded;
  }
}
